export class ExternalUserNotFoundError extends Error {
  constructor(email: string) {
    super(`External user ${email} not found`);
  }
}
